import { render, staticRenderFns } from "./RepCajaView.vue?vue&type=template&id=5dbfb934"
import script from "./RepCajaView.vue?vue&type=script&lang=js"
export * from "./RepCajaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports